import React, { useEffect, useRef } from 'react';
var NotificationTabConfigItem = /** @class */ (function () {
    function NotificationTabConfigItem() {
    }
    return NotificationTabConfigItem;
}());
export { NotificationTabConfigItem };
var NotificationTabConfig = /** @class */ (function () {
    function NotificationTabConfig() {
    }
    return NotificationTabConfig;
}());
export { NotificationTabConfig };
var VeltNotificationsTool = function (props) {
    var children = props.children, darkMode = props.darkMode, onNotificationClick = props.onNotificationClick, shadowDom = props.shadowDom, panelShadowDom = props.panelShadowDom, variant = props.variant, maxDays = props.maxDays, tabConfig = props.tabConfig, panelOpenMode = props.panelOpenMode, panelVariant = props.panelVariant, readNotificationsOnForYouTab = props.readNotificationsOnForYouTab, settings = props.settings, selfNotifications = props.selfNotifications, considerAllNotifications = props.considerAllNotifications;
    var ref = useRef();
    var onNotificationClickRef = useRef(onNotificationClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onNotificationClickRef.current = onNotificationClick;
    }, [onNotificationClick]);
    useEffect(function () {
        var element;
        var handleNotificationClick = function (event) {
            if (onNotificationClickRef.current) {
                onNotificationClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element === null || element === void 0 ? void 0 : element.addEventListener('onNotificationClick', handleNotificationClick);
            }
        }
        return function () {
            if (element) {
                element === null || element === void 0 ? void 0 : element.removeEventListener('onNotificationClick', handleNotificationClick);
            }
        };
    }, []);
    return (React.createElement("velt-notifications-tool", { ref: ref, "panel-open-mode": panelOpenMode, panelVariant: panelVariant, "tab-config": JSON.stringify(tabConfig), variant: variant, "max-days": (maxDays && maxDays > 0) ? maxDays + '' : undefined, "panel-shadow-dom": [true, false].includes(panelShadowDom) ? (panelShadowDom ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, settings: [true, false].includes(settings) ? (settings ? 'true' : 'false') : undefined, "self-notifications": [true, false].includes(selfNotifications) ? (selfNotifications ? 'true' : 'false') : undefined, "read-notifications-on-for-you-tab": [true, false].includes(readNotificationsOnForYouTab) ? (readNotificationsOnForYouTab ? 'true' : 'false') : undefined, "consider-all-notifications": [true, false].includes(considerAllNotifications) ? (considerAllNotifications ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsTool;
